export default "/images/3240756cbea08f0e86f38830f3a73fd7.avif";